import React from 'react';
import { LandingSearchForm } from '../../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { types as sdkTypes } from '../../../../util/sdkLoader';
import { useLocation } from 'react-router-dom';
import { createResourceLocatorString } from '../../../../util/routes';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';

import css from './SectionHero.module.css';
import { formatDateRangeForTimezone } from '../../../../util/genericHelpers';
import moment from 'moment';
import { parse } from '../../../../util/urlHelpers';

const { LatLng, LatLngBounds } = sdkTypes;

function RenderLandingPageSectionHero(props) {
  const { isTopbarSearch, showTopbarSearch, showSecondDiv } = props;
  const history = useHistory();
  const location = useLocation();
  const routeConfiguration = useRouteConfiguration();
  const { keywords: keywordsFromURL } = parse(location.search || '');
  const initialValues = {
    keywords: keywordsFromURL != null ? `${keywordsFromURL}` : '',
  };

  const handleSubmit = values => {
    const { keywords = null, location = null, dates } = values || {};

    const searchQuery = {};
    if (keywords) searchQuery.keywords = keywords;
    const { search = 'Thailand', selectedPlace } = location || {};
    const defaultBounds = new LatLngBounds(
      new LatLng(14.3, 101.1), // North-East
      new LatLng(13.2, 99.9) // South-West
    );
    const { bounds = defaultBounds } = selectedPlace || {};
    Object.assign(searchQuery, { address: search, bounds });

    if (dates?.startDate) {
      const start = dates.startDate;
      // Add exactly one day:
      const end = moment(start)
        .add(1, 'day')
        .toDate();

      // Pass both into your formatter:
      const dateRange = formatDateRangeForTimezone({
        startDate: start,
        endDate: end,
      });

      if (dateRange) {
        searchQuery.dates = dateRange;
      }
    }

    history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, searchQuery));
  };

  return (
    <LandingSearchForm
      rootClassName={css.landingSearchForm}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      isTopbarSearch={isTopbarSearch}
      showTopbarSearch={showTopbarSearch}
      showSecondDiv={showSecondDiv}
    />
  );
}

export default RenderLandingPageSectionHero;
